import { useQuery } from '@tanstack/react-query';

import { TEN_MINUTES_IN_MS, THIRTY_MINUTES_IN_MS } from '@/legacy/constants';
import { DELEGATIONS_OPTIONS } from '@/legacy/constants/queryKeys';
import { Option } from '@/legacy/types';
import { markOptionsAsNonTranslatable } from '@/shared/utils/markOptionsAsNonTranslatable';

import { fetchDelegationOptions } from '../service/delegationOptions';
import {
	DelegationOptionsParams,
	mapDelegationOptionsParamsToApi,
} from '../mappers/delegationOptions';

export const useDelegationOptions = (
	params?: DelegationOptionsParams,
	options?: { enabled?: boolean },
) => {
	const apiParams = mapDelegationOptionsParamsToApi(params);
	// Use a value-stable key so we refetch only when params values change
	const paramsKey = apiParams ? JSON.stringify(apiParams) : '';

	const { data, isLoading, error } = useQuery<Option[]>({
		queryKey: [DELEGATIONS_OPTIONS, paramsKey],
		queryFn: () => fetchDelegationOptions(params),
		staleTime: TEN_MINUTES_IN_MS,
		gcTime: THIRTY_MINUTES_IN_MS,
		refetchOnWindowFocus: false,
		retry: false,
		enabled: options?.enabled,
	});

	// Delegation names are user data: without this the legacy Select runs each label through t()
	// (see Select/primitives/Option.tsx), so a delegation named e.g. "all" would render translated.
	return { data: markOptionsAsNonTranslatable(data ?? []), isLoading, error };
};
